module.exports = __webpack_public_path__ + "img/sergeant-reason-icon5.aaa5bf1e.png";